import React, { PureComponent } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Loading from 'modules/common/components/loading';

const ForgotPassword = React.lazy(() => import('modules/auth/components/forgotPassword.component'));
const ActivateAccount = React.lazy(() => import('modules/auth/components/activateAccount.component'));
const Login = React.lazy(() => import('modules/auth/components/login.container'));
const Home = React.lazy(() => import('./home.container'));

class App extends PureComponent {
  render() {
    return (
      <Router>
        <React.Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/account-activation/:token" component={ActivateAccount} />
            <Route exact path="/login" component={Login} />
            <Route path="/" component={Home} />
          </Switch>
          <ToastContainer autoClose={3000} />
        </React.Suspense>
      </Router>
    );
  }
}

App.propTypes = {};

App.defaultProps = {};

export default App;
